export const preSaleAddress = "0x6fD1cf06c0667D7C71EE2Dc21e84E278737b2a2F";
export const pltToken = "0x1E3B5Ac35B153BB0A6F6C6d46F05712E102FE42E";
